import UnregisterDeviceConfirmation from './UnregisterDeviceConfirmation';
export default UnregisterDeviceConfirmation;
